/**
 * Shared launcher visuals — dark panel, elevated surfaces (Google app drawer–inspired).
 */
export const LAUNCHER = {
  panelRadius: '22px',
  /** Neutral dark — avoids muddy/warm cast so white type reads cleaner. */
  panelBg: '#1f1f1f',
  /** Omit blur on solid dark panel. */
  panelBackdropBlur: undefined,
  panelShadow:
    '0 16px 48px rgba(0, 0, 0, 0.48), 0 8px 24px rgba(0, 0, 0, 0.28), 0 0 0 1px rgba(255, 255, 255, 0.07)',

  favoritesSurfaceRadius: '16px',
  favoritesSurfaceBg: '#2a2a2a',
  favoritesSurfaceShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.1)',
  favoritesPadding: 4, // 16px

  /** Uniform tile width (favorites + all tools); labels may use 2 lines. */
  appTileWidth: '88px',
  appTileWidthPx: 88,
  /** Room for 44px well + two 14px label lines (line-height 1.25). */
  appTileMinH: '102px',

  /** Product-style icons in launcher tiles (not header). */
  launcherIconSize: 28,
  launcherIconWell: '44px',

  titleFavorites: {
    fontSize: '12px',
    fontWeight: '600',
    letterSpacing: '0.08em',
    color: 'rgba(255, 255, 255, 0.72)',
    textTransform: 'uppercase',
  },
  titleAllTools: {
    fontSize: '12px',
    fontWeight: '600',
    letterSpacing: '0.08em',
    color: 'rgba(255, 255, 255, 0.66)',
    textTransform: 'uppercase',
  },

  /** Tile app names — high legibility on dark (Google-style clarity). */
  tileAppLabel: {
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '1.25',
    letterSpacing: '-0.01em',
    color: 'rgba(255, 255, 255, 0.88)',
    textAlign: 'center',
  },

  /** Empty states / hints inside the panel. */
  bodyMuted: {
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '1.35',
    color: 'rgba(255, 255, 255, 0.72)',
    textAlign: 'center',
  },
};
